import React, { useState, useEffect } from 'react';
import {
  ChevronLeft,
  ChevronRight,
  ArrowUpDown,
  ArrowUp,
  ArrowDown,
  Settings,
} from 'lucide-react';
import { loadList } from 'shared/api/requests';
import { useLayout } from 'shared/contexts/LayoutContext';
import { useStateContext } from 'shared/contexts/ContextProvider';
import Filter from 'shared/ui/Filter';
import Tooltip from 'shared/ui/Tooltip';



const Stats = ({ targetUrl, filterOptions, ChartComponent, exportUrl }) => {
  const [stats, setStats] = useState([]);
  const { openModal, isLoading, setIsLoading } = useLayout();
  const { currentColor, showToast, token } = useStateContext();



  const constructQueryParams = (searchValue, filters) => {
    const queryParams = [];

    if (searchValue) {
      queryParams.push(`search=${searchValue}`);
    }
    const filterParams = [];
    filterOptions.forEach(({ key, postProcess }) => {
      if (filters[key]) {
        if (postProcess) {
          filterParams.push(postProcess(filters[key]));
        } else if (Array.isArray(filters[key])) {
          if (filters[key].length > 0) {
            filterParams.push(`${key}=[${filters[key].map((item) => item.id ? item.id : item).join(',')}]`);
          }
        } else {
          filterParams.push(`${key}=${filters[key]}`);
        }
      }
    });

    if (filterParams.length > 0) {
      queryParams.push(`filter=${filterParams.join(';')}`);
    }

    return queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
  };



  const fetchStats = async (searchValue = '', filters = []) => {
    try {
      console.log('fetchStats');
      setIsLoading(true);
      if (targetUrl.includes('?')) {
        const response = await loadList(`${targetUrl}`, '', token);
        setStats(response);
      } else {
        const queryString = constructQueryParams(searchValue, filters);
        const response = await loadList(`${targetUrl}`, queryString, token);
        setStats(response);
      }
    } catch (error) {
      showToast({
        title: 'Error!',
        content: error.message || 'Something went wrong!',
        type: 'error',
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (targetUrl.includes('?')) {
      fetchStats();
    }
  }, []);

  const handleExport = async () => {
    if (!exportUrl) return;

    try {
      // If exportUrl is a function, call it to get the current URL
      const currentExportUrl = typeof exportUrl === 'function' ? exportUrl() : exportUrl;
      await exportList(currentExportUrl, '', token);
      showToast({
        title: 'Success!',
        content: 'Export completed successfully!',
        type: 'success',
      });
    } catch (error) {
      showToast({
        title: 'Error!',
        content: error.message || 'Export failed!',
        type: 'error',
      });
    }
  };



  return (
    <div className=' p-4 space-y-4'>
      {filterOptions && (
        <Filter
          filterOptions={filterOptions}
          fetchItems={fetchStats}
          exportItems={exportUrl ? handleExport : undefined}
        />
      )}
      {ChartComponent && <ChartComponent data={stats} />}
    </div>
  );
};

export default Stats;
